<template>
  <div class="list">
    <v-container class="my-7" v-if="!loading">
      <banner type="top" class="mb-7" />

      <Title no-decoration>{{ title }}</Title>

      <div v-if="totalItems" class="list-container">
        <div class="list-item">
          <component
            v-for="(item, i) in items"
            :is="cardComponentName"
            :key="i"
            v-bind="item"
          ></component>
        </div>

        <v-pagination
          v-model="page"
          :length="pagesLength"
          :total-visible="9"
          v-if="pagesLength > 1"
        ></v-pagination>
      </div>
      <v-alert v-else name="warn" type="warning" class="mt-6">
        Nenhum conteúdo adicionado até o momento.
      </v-alert>

      <banner type="center-2" class="mt-7" />
    </v-container>
    <v-sheet
      v-else
      class="d-flex justify-center align-center my-16"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
  </div>
</template>

<script>
import Banner from "@/components/cards/Banner.vue";
import Title from "@/components/widgets/Title.vue";
import VideoCard from "@/components/cards/Video.vue";

const _config = {
  title: "Vídeos",
  mod: "videos",
  itemsPerPage: 24,
  cardComponentName: "video-card",
};

export default {
  data: () => ({
    loading: true,
    items: [],
    totalItems: 0,
    title: _config.title,
    cardComponentName: _config.cardComponentName,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / _config.itemsPerPage);
    },
  },
  created() {
    this.get();
  },
  watch: {
    page() {
      this.get();
    },
  },
  methods: {
    get() {
      const params = {
        itemsPerPage: _config.itemsPerPage,
        returnTotalItems: 1,
      };

      if (this.page) params.page = this.page;

      this.loading = true;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list;
            this.totalItems = totalItems;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    Banner,
    VideoCard,
    Title,
  },
};
</script>

<style scoped>
.list-container {
  display: grid;
  gap: 30px;
  margin-top: 30px;
}

.list-item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 40px 16px;
}

@media screen and (max-width: 960px) {
  .list-item {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media screen and (max-width: 600px) {
  .list-item {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
